import React from "react";
import PositionTable from "./table";
import { Leg } from "./../../types";

interface AnalyzeProps {
  strategy: Leg[];
  lotSize: number;
  positionFields: any[];
  removeFromStrategy: Function;
  clearStrategy: Function;
}

export function AnalyzePosition(props: AnalyzeProps) {
  const {
    strategy,
    positionFields,
    removeFromStrategy,
    clearStrategy,
  } = props;

  return (
    <div
      style={{ marginTop: "20px", marginBottom: "10px" }}
      className="e-field"
    >
      <b>Positions in strategy</b>

      <PositionTable
        dataSource={strategy}
        fields={positionFields}
        onRowRemoved={removeFromStrategy}
        onClearAll={clearStrategy}
        showRemoveIcon={true}
      ></PositionTable>
    </div>
  );
}
